import { useGetCertificationCompletion } from 'queryHooks/Admin/analytics';
import { SingleCertificateTrendChartCard } from '../../components/SingleCertificateTrendChartCard/SingleCertificateTrendChartCard';
import { NoData } from '../../components/NoData/NoData';
import { CertificationCompletionEntry } from 'types/admin/analytics';
import { generateChartColors } from 'utilities/chartsColorPalette';
import { CertificationTrendsChartCard } from '../../components/CertificationTrendsChartCard/CertificationTrendsChartCard';

export const CertificationsTab = () => {
  const {
    data: certificationCompletion,
    isLoading: certificationCompletionLoading,
    isError: certificationCompletionError,
  } = useGetCertificationCompletion();

  const allCompletions = certificationCompletion
    ? Object.entries(certificationCompletion.completionByCertificationId).reduce(
        (acc, [key, value]) => ({ ...acc, [key]: value }),
        {} as Record<string, CertificationCompletionEntry>
      )
    : {};

  const filteredCompletions = Object.entries(allCompletions).filter(
    ([, entry]) => entry.userCountsByDate && Object.keys(entry.userCountsByDate).length > 0
  );

  const colors = generateChartColors(filteredCompletions.length);

  return (
    <div className='analytics-tab'>
      {certificationCompletionError || certificationCompletionLoading || !certificationCompletion ? (
        <NoData loading={certificationCompletionLoading} error={certificationCompletionError} noData={!certificationCompletion} />
      ) : (
        <>
          <div className='overview-section'>
            <CertificationTrendsChartCard trends={filteredCompletions} chartColors={colors} />
          </div>
          <div className='overview-section'>
            <div className='section-grid trends'>
              {filteredCompletions.map(([certificationId, entry], index) => (
                <SingleCertificateTrendChartCard key={certificationId} completions={[certificationId, entry]} color={colors[index]} />
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
